import { render, staticRenderFns } from "./OrgAuthPage.vue?vue&type=template&id=4bced56c&scoped=true&"
import script from "./OrgAuthPage.vue?vue&type=script&lang=js&"
export * from "./OrgAuthPage.vue?vue&type=script&lang=js&"
import style0 from "./OrgAuthPage.vue?vue&type=style&index=0&id=4bced56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bced56c",
  null
  
)

export default component.exports